module.exports = __webpack_public_path__ + "static/media/img7.4f2c6417.jpg";